<template>
	<div>
		<TableList :form_data_seo.sync="form_data_seo" :columns="columns" :get_table_list="this.get_table_list"
			:slot_table_list="['operation']" ref="list" rowKey="id" :submit_preprocessing="submit_preprocessing">
			<template slot="left_btn">
				<a-button @click="resend('all')" type="primary" style="margin-left: 15px;">重新推送</a-button>
			</template>
			<template slot="operation" slot-scope="data">
				<a v-if='data.record.push_status==0' @click="resend('part',data.record.id)">重新推送</a>
			</template>
		</TableList>
		<a-modal @ok="goReportFun" title="提示内容" :visible="resend_visible" :width="'400px'"
			@cancel="resend_visible = false">
			<p>
				确认重推{{type=='all'?'所有推送失败':''}}数据至DRP系统，点击确认立即重推。
			</p>
		</a-modal>

	</div>
</template>

<script>
	import TableList from "@/components/TableList";
	import {
		message,
		Modal

	} from 'ant-design-vue'
	import {
		getPushDrpRecord,
		getPushDrpSelect,
		pushAgain
	} from "@/api/freezer";

	const columns = [{
			title: "推送内容",
			dataIndex: "push_content",
				width: 120,
		},
		{
			title: "推送类目",
			dataIndex: "type_name",
				width: 120,
		},
		{
			title: "所属经销商",
			dataIndex: "seller_name",
				width: 120,
		},
		{
			title: "关联单号",
			dataIndex: "order_no"
		},
		{
			title: "推送状态",
				width: 100,
			dataIndex: "push_status_name",
		},
		{
			title: "失败原因",
			dataIndex: "error_remark",
			width: 300,
		},
		{
			title: "自动推送时间",
			dataIndex: "create_time"
		},
		{
			title: "最新推送时间",
			dataIndex: "update_time"
		},
		{
			title: "操作",
			dataIndex: "operation",

			scopedSlots: {
				customRender: "operation"
			}
		}
	];

	export default {
		name: "Index",
		components: {
			TableList,
			Modal
		},
		data() {
			return {
				resend_visible: false,
				get_table_list: getPushDrpRecord,
				submit_preprocessing: {
					array_to_string: ['department_id']
				},
				columns,
				type: null,
				type_id: null,
				form_data_seo: {
					...this.$config.form_data_seo,
					list: [{
							type: "text",
							name: "order_no",
							title: "关联订单号",
							options: {},
						},{
							type: "select",
							name: "type",
							title: "推送类目",
							options: {},
							list: []
						},
						{
							type: "select",
							name: "push_status",
							title: "推送状态",
							list: [{
								value: '推送成功',
								key: 1
							}, {
								value: '推送失败',
								key: 0
							}]
						},
						
						{
							type: "range_date",
							name: "range_date",
							title: "自动推送时间",
							start: {
								name: 'start_time'
							},
							end: {
								name: 'end_time'
							},
						},
						{
							type: "range_date",
							name: "update_range_date",
							title: "最新推送时间",
							start: {
								name: 'update_start_time'
							},
							end: {
								name: 'update_end_time'
							},
						},
					],
				}
			};
		},
		async created() {
			getPushDrpSelect().then(res => {
				let arr = res.data.list.map(it => {
					return {
						key: it.value,
						value: it.label
					}
				})
				this.form_data_seo.list = this.$method.set_form_list(this.form_data_seo.list, 'type',
					'list', arr)
			});
		},
		methods: {
			resend(type, id) {
				this.type = type
				this.type_id = id ? id : null
				this.resend_visible = true
			},
			goReportFun() {

				pushAgain({
					data: {
						"type": this.type, //类型 all一键重推 part部分推送
						"id": this.type_id //推送记录id，部分推送时必传
					}
				}).then(res => {
					this.resend_visible = false;
					this.$refs.list.get_list()
					message.success(res.info);
				})
			},
		}
	};
</script>

<style lang="less">

</style>